import React from 'react';
import { connect, useSelector } from 'react-redux';
import { GlobalState } from 'ha/types/store';
import { getMediaQueryBreakpoints } from 'ha/modules/UI/selectors';
import useCSSMediaQuery from '@material-ui/core/useMediaQuery';

export interface MediaQueryBreakpoints {
  xs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
}

interface Props {
  mediaQueryBreakpoints: MediaQueryBreakpoints;
  children: (
    mediaQueryBreakpoints: MediaQueryBreakpoints,
  ) => JSX.Element | null;
}

const MediaQuery: React.FC<Props> = ({ children, mediaQueryBreakpoints }) =>
  children(mediaQueryBreakpoints);

export default connect((state: GlobalState) => ({
  mediaQueryBreakpoints: getMediaQueryBreakpoints(state),
}))(MediaQuery);

export function useMediaQuery(): MediaQueryBreakpoints {
  return useSelector(getMediaQueryBreakpoints);
}

export function useOrientation(): 'portrait' | 'landscape' {
  const isPortrait = useCSSMediaQuery('(orientation: portrait)');

  return isPortrait ? 'portrait' : 'landscape';
}
